<script>
export default {
  name: "DidoCodeHightlighting",
};
</script>

<script setup>
import DidoCodeHightlightingJs from "./Javascript.vue";
import DidoCodeHightlightingShell from "./Shell.vue";

// define Props
const props = defineProps({
  language: { type: String, required: true },
  code: { type: String, required: true },
});
</script>

<template>
  <div class="dido-code-highlighting">
    <DidoCodeHightlightingJs
      v-if="props.language === 'javascript'"
      :code="props.code"
    />
    <DidoCodeHightlightingShell
      v-if="props.language === 'shell'"
      :code="props.code"
    />
  </div>
</template>

<style lang="sass">
@use 'sass:meta'
.dido-code-highlighting
  @include meta.load-css("highlight.js/styles/atom-one-dark.css")
</style>
